import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { Tooltip, Tabs, message } from 'antd'
import cloneDeep from 'lodash/cloneDeep'

import { Flex, FlexColumn, CardContainer, LightContainer } from '../../Reusable/Container'
import PageHeader from '../../Reusable/PageHeader'
import { LabeledInput } from '../../Reusable/Input'
import { Dropdown, Menu } from '../../Reusable/Dropdown'
import { Button, TextButton, Chip, ImageButton } from '../../Reusable/Button'
import { ErrorAlert } from '../../Reusable/Alert'
import { ApprovalJourney } from '../../Reusable/Approval'
import { Text, Tag } from '../../Reusable/Text'
import { Image } from '../../Reusable/Image'
import CancelModal from '../../Reusable/CancelModal'
import { apiPOSTReq } from '../../../Utils/api'
import environment from '../../../environment'
import { addDataToStore, BNK_SAVE_DATA } from '../../../Actions/actions'
import moment from 'moment'
import { crbAddressObjectToStr, getBPAccountsWithAccess, getResourcePerm, toCurrency } from '../../../Utils/util'
import SearchAndFilter from './SearchAndFilter'
import _ from 'underscore'

// Images
import { LoadingOutlined } from '@ant-design/icons'
import TableView from '../../Reusable/TableView'
import Visibility from "../../../Images/visibility-blue.png"
import VisibilityOff from "../../../Images/visibility-off.png"

const { TabPane } = Tabs

const pageSize = 50;

class Accounts extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            pagination: {
                current: 1,
                pageSize: pageSize,
            },
            sortFieldname: "businessName",
            sortDirection: "ASC",
            accounts: [],
        }
    }

    componentDidMount() {
        this.getDACAAccounts({ pagination: this.state.pagination })
    }

    handleSearchChange = (e) => {
        this.setState({ [e.target.id]: e.target.value, wireSelected: false, achSelected: false, recipientSelected: false, dropdownVisible: false, approvedSelected: false, rejectedSelected: false }, this.fetchOutbox)
    }

    getDACAAccounts = (options) => {
        const { sortFieldname, sortDirection, accounts } = this.state
        var { pagination, sorter, searchTerm, fromAmount, toAmount } = options || {}

        console.log("DACAAccounts getDACAAccounts options", options)

        if (!pagination) pagination = {
            current: 1,
            pageSize: pageSize
        }

        const body = {
            size: pagination.pageSize || 100,
            page: (pagination.current || 1) - 1,
            sortFieldname,
            sortDirection,
        }

        if (sorter?.field) {
            if (sorter.field === sortFieldname) {
                body.sortDirection = (sortDirection === "DESC") ? "ASC" : "DESC"
            } else {
                body.sortDirection = "ASC"
            }
            body.sortFieldname = sorter.field
        }

        if (searchTerm) body.searchStr = searchTerm

        if (_.isNumber(fromAmount) && _.isNumber(toAmount)) {
            body.fromAmt = fromAmount
            body.toAmt = toAmount
        }

        console.log("DACAAccounts getDACAAccounts body", body)

        this.setState({ loading: true })

        apiPOSTReq(`${environment.bbBaseUrl}/daca/getAccounts`, null, body, (err, resp) => {
            try {
                console.log("/daca/getAccounts", err, resp)
                const data = resp
                if (data.result) {
                    if (err) throw new Error(err)
                    // var accounts = data.accounts

                    console.log("DACAAccounts getDACAAccounts resp", data)


                    const newData = pagination?.current > 1 ? accounts.concat(data.accounts) : data.accounts

                    this.setState({
                        accounts: newData,
                        sortFieldname: body.sortFieldname,
                        sortDirection: body.sortDirection,
                        pagination: pagination,
                        moreToLoad: newData.length !== data.dacaAccountsCount,
                    })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
            } finally {
                this.setState({ loading: false, loadingMore: false })
            }
        })
    }

    onLoadMore = () => {
        const { pagination } = this.state

        this.setState({ loadingMore: true })
        this.getDACAAccounts({
            pagination: {
                current: pagination.current + 1,
                pageSize: pageSize,
            }
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.getDACAAccounts({ pagination: pagination, sorter: sorter });
    }

    render() {
        const { moreToLoad, accounts, loading, loadingMore, cards, body, payBody,
            showCancel, cardToCancel, objectDetail, cancelLoading, approvalsTab, originalCards } = this.state
        const { theme, noHeader } = this.props

        const completedColumns = [
            {
                title: 'Business Name',
                dataIndex: 'businessName',
                key: 'businessName',
                sorter: true,
                render: (businessName, account) => {
                    return <a style={{ textDecoration: "underline", color: "#1199FF" }}><Text primary>{businessName}</Text></a>
                },
            },
            {
                title: 'Account Number',
                dataIndex: 'accountNumber',
                key: 'accountNumber',
                render: (accountNumber, account) => {
                    return <Flex start bottom style={{ width: 170 }}>
                        <LabeledInput
                            nomargin
                            type='read-only'
                            noWidth
                            // width='220px'
                            value={account?.unmasked ? accountNumber : `•••••${accountNumber.substring(accountNumber.length - 4, accountNumber.length)}`}
                        />

                        <img style={{ cursor: 'pointer', marginLeft: 12 }} onClick={(e) => {
                            e.stopPropagation();
                            account.unmasked = !account?.unmasked
                            this.setState({ Accounts })
                        }} width='20px' height='20px' src={account?.unmasked ? VisibilityOff : Visibility} />
                    </Flex>
                },
            },
            {
                title: 'Available Balance',
                dataIndex: 'availableBalance',
                key: 'availableBalance',
                sorter: true,
                render: (availableBalance, account) => {
                    return `$${toCurrency(availableBalance)}`
                }
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                render: (status, record) => {
                    var color = theme.colors.secondary7
                    var background
                    var status = status
                    if (record.orderStatus === 'OrderPending') {
                        color = theme.colors.primary
                        background = theme.colors.backgroundPrimary
                        status = 'Processing'
                    } else if (status === 'Unactivated') {
                        color = theme.colors.primary
                        background = theme.colors.backgroundPrimary
                        status = 'Issued'
                    } else if (status === 'Suspended') {
                        color = theme.colors.redDeep
                        background = theme.colors.redPale
                        status = 'Locked'
                    } else if (status === 'Active') {
                        color = theme.colors.greenDeep
                        background = theme.colors.greenPale
                    } else if (status === 'Closed') {
                        status = 'Canceled'
                    } else {
                        status = 'Inactive'
                    }

                    return (
                        <Tag color={color} background={background}>{status}{status === 'Processing' && <LoadingOutlined style={{ color: this.props.theme.colors.primary, marginLeft: 8 }} />}</Tag>
                    )
                },
            },
        ]

        return (
            <>
                <FlexColumn className={!noHeader && 'main-padding'} style={{ margin: noHeader ? '24px 24px 0 0' : 0 }}>
                    {
                        !noHeader &&
                        <PageHeader
                            titleText="DACA Accounts"
                            subtitle='Cards'
                        // ctaContent={<Button onClick={() => this.props.history.push('/cards/issue-card')} permtype="Override" solid text='ISSUE NEW CARD' />}
                        />
                    }
                    {/* <SearchAndFilter type={(paymentsPerm.approve || recipientsPerm.approve) ? 'Banking' : 'Bill Payments'} onChange={(options) => (paymentsPerm.approve || recipientsPerm.approve) ? this.fetchOutbox(options) : this.fetchPayOutbox(options)} /> */}
                    <TableView
                        id="completed-table"
                        tableLayout='auto'
                        columns={completedColumns}
                        dataSource={accounts}
                        rowKey='accountId'
                        titleText='Overview'
                        descText='View a list of your DACA accounts'
                        loading={loading}
                        loadingMore={loadingMore}
                        pagination={false}
                        onChange={this.handleTableChange}
                        // ctaContent={
                        //     !noHeader &&
                        //     <Button onClick={() => this.props.history.push({
                        //         pathname: '/cards/issue-card',
                        //         state: { backOnConfirm: true }
                        //     })} permtype="Override" solid text='ISSUE NEW CARD' />
                        // }
                        onLoadMore={this.onLoadMore}
                        moreToLoad={moreToLoad}
                        pageSize={pageSize}
                        onRow={
                            (account, rowIndex) => {
                                return {
                                    onMouseUp: (event) => {
                                        // Only prevent propagation if it's a text selection attempt
                                        if (!account.selecting && window.getSelection().toString()) {
                                            account.selecting = true;
                                        } else {
                                            account.selecting = false;
                                        }
                                    },
                                    onClick: event => {
                                        if (!account.selecting) {
                                            this.props.history.push({
                                                pathname: '/daca/transactions',
                                                state: { accountId: account?.accountId }
                                            })
                                        }
                                    }, // click row
                                }
                            }
                        }
                        ctaContent={
                            <SearchAndFilter
                                fetchData={(options) => {
                                    // var stateToSave = Object.assign(options, { sortDirection: this.state.sortDirection, sortFieldName: this.state.sortFieldName });
                                    // this.setState(stateToSave, () => this.fetchBills(stateToSave));
                                    this.getDACAAccounts(options)
                                }}
                            />
                        }
                    />
                </FlexColumn>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Accounts)))